<template>
  <div class="number-of-words">
    <div class="mt-1 bg-white border-top border-bottom p-2 pb-3">
      <h3 class="mb-2"><!--@click="open=!open"-->
        {{hebrew ? 'מספר מילים' : 'Number of words'}}<!-- 
        <i v-if="open" class="fas fa-caret-down"></i>
        <i v-else class="fas fa-caret-up"></i> -->
      </h3>
     
      <vue-slider
       class="px-2 pb-4" 
       v-model="numValue" 
       :dragOnClick="true" 
       :minRange=2
       :max=5
       :tooltip="'none'" 
       :interval="1"
       :marks="true"
       :height=9 
       :dotSize=20
       :data="numRange"
       @drag-end=numChanged()>
       </vue-slider>      
    </div>     
  </div>
</template>

<script>
import {Actions} from '@/store/stateChanges'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
export default {
  name: 'NumberOfWords',
  components: {VueSlider},
  data() {
    return {
      open: true,
      numRange: [2,3,4,5]
    }
  },
  props: [],
  methods: {
    numChanged() { 
      this.$store.dispatch(Actions.RUN_SEARCH)  
    }  
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },    
    numValue: {
      get () {
        return this.$store.state.wordsNum
      },  
      set (value) {
        this.$store.commit('SET_NUMBER_OF_WORDS', value) 
      }  
    }
  }
}
</script>
<style>
  .vue-slider-process {
    background: transparent;
  }
  .vue-slider-rail {
    background: #d6ecff;
  }
  .vue-slider-mark {
    background: #007ee5;
    border-radius: 2px;
  }
</style>

